<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Telephony Users</h1>
    </div>
    <div class="flex-shrink-1">
      <span class="md-inputfield filterItem">
        <i class="fa fa-search"></i>
        <input
          style="margin-left: 8px"
          name="searchUserName"
          type="text"
          pInputText
          [(ngModel)]="searchUserName"
          (input)="onUserSearch()"
        />
        <label style="margin-left: 16px">Search</label>
      </span>
    </div>
  </div>
</div>
<div class="content-container">
  <div class="flex">
    <button
      pButton
      type="button"
      label="Sync Users"
      class="ui-button ui-button-primary ui-button-success btn-to-right pull-right"
      (click)="syncUsers()"
      [disabled]="isLoading"
    ></button>
  </div>
  <p-table
    selectionMode="single"
    [value]="users"
    [lazy]="false"
    [paginator]="false"
    rowHover="false"
    resizableColumns="true"
    [class.no-zebra-shading]="true"
    [responsive]="true"
    [loading]="isLoading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 60px">Id</th>
        <th>User</th>
        <th>Phone</th>
        <th>Email</th>
        <th>Extension</th>
        <th>VME User Id</th>
        <th style="width: 180px">Updated</th>
        <th style="width: 80px">Enabled</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-userUntyped>
      <ng-container *ngIf="asTelephonyUser(userUntyped) as data">
        <tr>
          <td>
            {{ data.id }}
          </td>
          <td>{{ data.firstName }} {{ data.lastName }}</td>
          <td>
            {{ data.phoneNumbers[0] }}
          </td>
          <td>
            {{ data.emails[0] }}
          </td>
          <td>
            {{ data.extension }}
          </td>
          <td>
            {{ data.vmeUserId }}
          </td>
          <td>
            {{ data.lastUpdated | datex : 'dd/MM/yyyy hh:mm' }}
          </td>
          <td style="text-align: center">
            <p-checkbox
              [(ngModel)]="data.enabled"
              name="enabled"
              [ngModelOptions]="{ standalone: true }"
              binary="true"
              (onChange)="changeUserEnabled(data)"
            ></p-checkbox>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>
